import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { LayoutGrid, List } from "lucide-react";

interface ViewToggleProps {
  viewMode: "table" | "card";
  onViewModeChange: (mode: "table" | "card") => void;
}

export function ViewToggle({ viewMode, onViewModeChange }: ViewToggleProps) {
  return (
    <div className="inline-flex items-center rounded-md border border-input p-0.5">
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className={cn(
          "h-8 px-2",
          viewMode === "table" && "bg-muted shadow-sm",
        )}
        onClick={() => onViewModeChange("table")}
        aria-pressed={viewMode === "table"}
      >
        <List className="h-4 w-4" />
        <span className="sr-only">Table view</span>
      </Button>
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className={cn(
          "h-8 px-2",
          viewMode === "card" && "bg-muted shadow-sm",
        )}
        onClick={() => onViewModeChange("card")}
        aria-pressed={viewMode === "card"}
      >
        <LayoutGrid className="h-4 w-4" />
        <span className="sr-only">Card view</span>
      </Button>
    </div>
  );
}
